import { scrollToElement } from 'telia-front-react';

export const scrollUpToElement = (elementId: string, isMobileOrTablet: boolean) => {
  scrollToElement(document.getElementById(elementId), null, isMobileOrTablet ? 112 : 125);
};
